export default "https://cdn-static.gokick.com/assets/ed6531e95fd3f911890bedfaed34e81f4e5a2128/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";